import { render, staticRenderFns } from "./VModelArray.vue?vue&type=template&id=2aac75fe"
import script from "./VModelArray.vue?vue&type=script&lang=js"
export * from "./VModelArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports